/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Banner_DescriptionInputs */

const da_consent_banner_description = /** @type {(inputs: Consent_Banner_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nødvendige cookies holder dig logget ind og husker dit valg her. Med dit samtykke bruger vi også PostHog til at se, hvilke funktioner der bruges, og hvor appen går galt, og til at du kan sende os feedback. Du kan altid ændre dit valg. Læs mere i <a href="/privacy">privatlivspolitikken</a>.`)
};

/** @type {(inputs: Consent_Banner_DescriptionInputs) => LocalizedString} */
const en_consent_banner_description = da_consent_banner_description;

/**

* @param {Consent_Banner_DescriptionInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_banner_description = /** @type {((inputs?: Consent_Banner_DescriptionInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Banner_DescriptionInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_banner_description(inputs)
	return /** @type {LocalizedString} */ ("Nødvendige cookies holder dig logget ind og husker dit valg her. Med dit samtykke bruger vi også PostHog til at se, hvilke funktioner der bruges, og hvor appen går galt, og til at du kan sende os feedback. Du kan altid ændre dit valg. Læs mere i <a href=\"/privacy\">privatlivspolitikken</a>.")
});